import React from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Typography,
} from "@mui/material";

const cookiesData = [
    {
        name: "session_id",
        description: "Used to manage your session",
        type: "Session"
    },
    {
        name: "cookieConsent",
        description: "Stores your cookie consent preferences",
        type: "1 year"
    },
    {
        name: "_ga",
        description: "Google Analytics – helps measure website traffic",
        type: "2 years"
    },
    {
        name: "ga*",
        description: "Google Analytics – used for analytics tracking",
        type: "2 years"
    },
    {
        name: "_gcl_au",
        description: "Used by Google Ads for conversion tracking",
        type: "3 months"
    }
];

const CookieTables = (props) => {
    return (
        <div>
            {!props.notTable && <Typography variant="body1" color="text.primary">
                <strong>4.1</strong> The following first-party Cookies may be placed on your computer or device:
            </Typography>}
            {!props.notTable && <TableContainer component={Paper} sx={{ mt: 2, mb: 2 }}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ fontWeight: "bold", backgroundColor: "#10374A", color: "#fff" }}>
                                Name of Cookie
                            </TableCell>
                            <TableCell sx={{ fontWeight: "bold", backgroundColor: "#10374A", color: "#fff" }}>
                                Description
                            </TableCell>
                            <TableCell sx={{ fontWeight: "bold", backgroundColor: "#10374A", color: "#fff" }}>
                                Type / Duration
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {cookiesData.map((cookie, index) => (
                            <TableRow key={index}>
                                <TableCell>{cookie.name}</TableCell>
                                <TableCell>{cookie.description}</TableCell>
                                <TableCell>{cookie.type}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>}
            {!props.notTable && <Typography variant="body1" color="text.primary">
                <strong>4.2</strong> The following third-party Cookies may be placed on your computer or device. Our Site may include embedded content (such as YouTube videos or social media plugins), which may place Cookies on your device. We also use Cookies from third-party advertising and analytics partners to deliver relevant advertisements and measure performance. We do not control third-party Cookies, so please check the respective third-party websites for more information on their Cookie policies and how to manage them.
            </Typography>}

        </div>
    );
};

export default CookieTables;
